import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function AddLocationAltIcon(props: IconProps) {
    return <Icon {...props} iconKey={"add_location_alt"}/>
}
